import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Login from "./Components/Login";
import DashboardLayout from "./Components/Home";
import Dashboard from "./Components/Dashboard";
import QueMangment from "./Components/QueManagment";
import AddQuestionForm from "./Components/AddQueForm";
import AddParaForm from "./Components/ParaForm";
import ExamManagement from "./Components/ExamManagment";
import ExamDetails from "./Components/ExamView";
import CreateExam from "./Components/ExamCreateForm";
import ExamList from "./Components/ByFefault";
import ExamPreview from "./Components/DefaultPaper";
import PreviewPaper from "./Components/PreviewPaper";
import ExamEdit from "./Components/ExamEdit";
import PublishPaper from "./Components/PublishPaper";
import ResultTabel from "./Components/ResultTabel";
import ResultReview from "./Components/ResultView";
import AddQuestion from "./Components/AddQuestion";
import NotificationPanel from "./Components/Notification";
import Setting from "./Components/Setting";
import SettingEdit from "./Components/SettingEdit";
import BookManagement from "./Components/BookManagment";
import CreateBook from "./Components/CreateBook";
import BookView from "./Components/BookView";
import PaymentDetail from "./Components/PaymentDetail";
import BookEdit from "./Components/BookEdit";
import CumissionDetails from "./Components/CumissionDetails";
import CommissionAnalysis from "./Components/CumissionAnalysis";
import TeacherManagment from "./Components/TeacherManagment";
import TeacherForm from "./Components/TeacherForm";
import TeacherView from "./Components/TeacherView";
import TeacherEdit from "./Components/TeacherEdit";
import StudentManagment from "./Components/StudentManagment";
import AddStudent from "./Components/StudentForm";
import StudentProfile from "./Components/StudentView";
import StudentProfileEdit from "./Components/StudentEdit";
import SoftwarePurchase from "./Components/SoftwarePurchase";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />


        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route path='/dashboard' element={<Dashboard />} />


          <Route path='quemanagment' element={<QueMangment />} />
          <Route path='addqueform' element={<AddQuestionForm />} />
          <Route path='addpara' element={<AddParaForm />} />


          <Route path="exammanagment" element={<ExamManagement />} />
          <Route path="createexam" element={<CreateExam />} />
          <Route path="examview" element={<ExamDetails />} />
          <Route path="examedit" element={<ExamEdit />} />
          <Route path="publishpaper" element={<PublishPaper />} />
          <Route path="resulttabel" element={<ResultTabel />} />
          <Route path="resultview" element={<ResultReview />} />
          <Route path="addquestion" element={<AddQuestion />} />
          <Route path="bydefault" element={<ExamList />} />
          <Route path="exampreveiw" element={<ExamPreview />} />
          <Route path="previewpaper" element={<PreviewPaper />} />

          <Route path="bookmanagment" element={<BookManagement />} />
          <Route path="createbook" element={<CreateBook />} />
          <Route path="bookview" element={<BookView />} />
          <Route path="paymentdetail" element={<PaymentDetail />} />
          <Route path="bookedit" element={<BookEdit />} />
          <Route path="commissiondetail" element={<CumissionDetails />} />
          <Route path="cumissionanalysis" element={<CommissionAnalysis />} />

          <Route path="techermanagment" element={<TeacherManagment />} />
          <Route path="teacherform" element={<TeacherForm />} />
          <Route path="teacherview/:teacherUserId" element={<TeacherView />} />
          <Route path="teacheredit/:teacherUserId" element={<TeacherEdit />} />



          <Route path="studentmanagment" element={<StudentManagment />} />
          <Route path="studentform" element={<AddStudent />} />
          <Route path="studentview/:id" element={<StudentProfile />} />
          <Route path="studentedit/:id" element={<StudentProfileEdit />} />

          <Route path="settings/:id" element={<Setting />} />
          <Route path="settingedit/:id" element={<SettingEdit />} />

          <Route path="notification" element={<NotificationPanel />} />

          <Route path="softwarepurchase" element={<SoftwarePurchase />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;